import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useRef, useState } from 'react';
import { traceButtonClass } from './cx.js';
const MAX_EMAIL_LENGTH = 320;
// Shape check only; the API validates for real. It keeps obvious typos from leaving the page.
const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Work email entry that routes a person to their organization's sign-in (organization SSO discovery). */
export function EmailDiscoveryForm({ onSubmit, busy = false, error, defaultEmail = '', label = 'Work email', submitLabel = 'Continue', }) {
    const id = useId();
    const inputRef = useRef(null);
    const [email, setEmail] = useState(defaultEmail);
    const [localError, setLocalError] = useState(null);
    const message = localError ?? error ?? null;
    const errorId = `${id}-error`;
    function handleSubmit(event) {
        event.preventDefault();
        if (busy)
            return;
        const value = email.trim();
        if (!value || value.length > MAX_EMAIL_LENGTH || !EMAIL_SHAPE.test(value)) {
            setLocalError('Enter a valid work email address.');
            inputRef.current?.focus();
            return;
        }
        setLocalError(null);
        void onSubmit(value);
    }
    return (_jsxs("form", { className: "trace-auth-form", noValidate: true, onSubmit: handleSubmit, "aria-busy": busy || undefined, children: [_jsxs("div", { className: "trace-auth-field", children: [_jsx("label", { className: "trace-auth-label", htmlFor: `${id}-email`, children: label }), _jsx("input", { ref: inputRef, id: `${id}-email`, className: "trace-auth-input", type: "email", name: "email", autoComplete: "username", inputMode: "email", autoCapitalize: "none", spellCheck: false, required: true, readOnly: busy, value: email, onChange: (event) => {
                            setEmail(event.target.value);
                            if (localError)
                                setLocalError(null);
                        }, "aria-invalid": message ? true : undefined, "aria-describedby": message ? errorId : undefined }), message ? (_jsx("p", { id: errorId, className: "trace-auth-field__error", role: "alert", children: message })) : null] }), _jsx("button", { type: "submit", className: traceButtonClass('primary', { block: true }), disabled: busy, children: busy ? 'Checking' : submitLabel })] }));
}
//# sourceMappingURL=EmailDiscoveryForm.js.map